/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.credentials.rpc.AchievementRpc
 */

export const getAllAchievementsForUserRpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementRpc',
  rpcName: 'getAllAchievementsForUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAC8YwyJ1ro0BZEAXm2HbnMQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAchievementVisibilityRpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementRpc',
  rpcName: 'updateAchievementVisibility',
  auth: 'app',
  fingerprint: 'tC2tQvU8uV6xMJprMV0_GpEAXm2HbnMQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAchievementRpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementRpc',
  rpcName: 'createAchievement',
  auth: 'app',
  fingerprint: 'qQ9Btdr045axMJprMV0_GpEAXm2HbnMQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};